import React, { useContext } from 'react';
import {
    DialogContent,
    Dialog,
    DialogActions,
    DialogTitle,
    Button,
} from '@material-ui/core'
import clsx from 'clsx';
import Alert from '@material-ui/lab/Alert';
import { useHistory } from "react-router-dom";

import useStyles from '../../styles/components/rewards/stylesRewardShop';
import ActivityContext from '../../context/activity-context'

const CustomDialog = () => {

    const history = useHistory();
    const classes = useStyles();
    const { activityContext, challengeId, dispatch } = useContext(ActivityContext);

    const handleClose = () => {
        dispatch({
            type: 'SET_CUSTOMDIALOG', customDialog: {
                open: false,
                message: 'Please wait for a while...',
                severity: 'info',
                isLoading: true
            }
        });
        history.push(`/ChallengeDetail/${challengeId}`);
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth='md'
            open={activityContext.customDialog.open}
            classes={{
                root: classes.rootDialogConfirm,
                paper: classes.paperDialogConfirm,
            }}
        >
            <DialogTitle disableTypography={true} style={{ fontSize: '20px' }} classes={{ root: classes.rootDialogConfirmTitle }}>
                Activity
            </DialogTitle>
            {
                activityContext.customDialog.isLoading ?
                    <Alert style={{ margin: "10px" }} variant="outlined" severity={activityContext.customDialog.severity}>{activityContext.customDialog.message}</Alert>
                    :
                    <>
                        <DialogContent classes={{ root: classes.rootDialogConfirmContent }}>
                            <Alert style={{ margin: "10px" }} variant="outlined" severity={activityContext.customDialog.severity}>{activityContext.customDialog.message}</Alert>
                        </DialogContent>
                        <DialogActions classes={{ root: classes.rootDialogActions }}>
                            <Button onClick={handleClose} className={clsx(classes.buttonDialogConfirm, classes.buttonYes)}>
                                Ok
                             </Button>
                        </DialogActions>
                    </>
            }
        </Dialog>
    );
};

export default CustomDialog;
